import React from "react";
import { Card, CardBody, CardHeader } from "reactstrap";
import {
    currencyFormatWithAlert,
    currencyFormatWithoutDecimal,
    numberFormat
} from "../../helpers/api_helper";

const CheckListingPopup = ({ data, currency }) => {
    console.log("DATA:", data);

    return (
        <React.Fragment>
            {/* Top Card */}
            <Card>
                <CardHeader className="d-flex flex-column flex-md-row justify-content-between bg-primary gap-3">
                    {/* Left Section */}
                    <div>
                        {/* Top Row */}
                        <div className="d-flex flex-wrap align-items-center gap-2 mb-2">
                            <p className="text-white mb-0 text-nowrap">
                                Cover : <span className="bg-white text-black px-2 rounded-1">{numberFormat(data.itemData.covers)}</span>
                            </p>
                            <p className="text-white mb-0 text-nowrap">
                                Avg Check : <span className="bg-white text-black px-2 rounded-1">{currencyFormatWithAlert(data.itemData.avg_check, currency)}</span>
                            </p>
                            <p className="text-white mb-0 text-nowrap">
                                Revenue : <span className="bg-white text-black px-2 rounded-1">{currencyFormatWithoutDecimal(data.itemData.revenue, currency)}</span>
                            </p>
                            <p className="text-white mb-1">Server :{" "}
                                <span className="bg-white text-black px-2 rounded-1">
                                    {data.itemData.employee}
                                </span>
                            </p>
                        </div>

                        {/* Bottom Row */}
                        <div className="d-flex flex-wrap align-items-center gap-2">
                            <p className="text-white mb-0 text-nowrap">
                                Opening Time :{" "}
                                <span className="bg-white text-black px-2 rounded-1">
                                    {data.itemData.open}
                                </span>
                            </p>
                            <p className="text-white mb-0 text-nowrap">
                                Closing Time :{" "}
                                <span className="bg-white text-black px-2 rounded-1">
                                    {data.itemData.close}
                                </span>
                            </p>
                        </div>
                    </div>


                </CardHeader>

                <CardBody>
                    <div className="table-responsive">
                        <table className="table table-borderless align-middle text-center mb-0">
                            <thead className="text-muted table-light">
                                <tr>
                                    <th>Item Name</th>
                                    <th>Category</th>
                                    <th>Quantity</th>
                                    <th>Revenue</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data?.allItems && data.allItems.length > 0 ? (
                                    data.allItems.map((item, index) => (
                                        <tr key={index}>
                                            <td>{item.item}</td>
                                            <td>
                                                <span className="badge bg-light text-dark">
                                                    {item.category || "-"}
                                                </span>
                                            </td>
                                            <td>{numberFormat(item.qty)}</td>
                                            <td>{currencyFormatWithoutDecimal(item.revenue, currency)}</td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="4" className="text-center text-muted">
                                            No items found
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </CardBody>

            </Card>

            {/* Discount Card */}
            <Card className="mt-3">
                <CardHeader className="bg-primary">
                    <h5 className="text-white mb-0">Discount</h5>
                </CardHeader>
                <CardBody>
                    <div className="table-responsive">
                        <table className="table table-borderless align-middle text-center mb-0">
                            <thead className="text-muted table-light">
                                <tr>
                                    <th>Item Name</th>
                                    <th>Category</th>
                                    <th>Quantity</th>
                                    <th>Discount Name</th>
                                    <th>Discount Amount</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data?.discountedItems && data.discountedItems.length > 0 ? (
                                    data.discountedItems.map((item, index) => (
                                        <tr key={index}>
                                            <td>{item.item}</td>
                                            <td>
                                                <span className="badge bg-light text-dark">
                                                    {item.category || "N/A"}
                                                </span>
                                            </td>
                                            <td>{numberFormat(item.qty)}</td>
                                            <td>{item.discount_name}</td>
                                            <td>{currencyFormatWithoutDecimal(item.discount, currency)}</td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="4" className="text-center text-muted">
                                            No discounted items found
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </CardBody>
            </Card>


            {/* Summary Table */}
            <div className="table-responsive mt-3">
                <table className="table text-center m-0">
                    <tbody>
                        {/* ✅ Loop through masterClassBreakup */}
                        {data?.masterClassBreakup &&
                            Object.entries(data.masterClassBreakup).map(([key, value], index) => (
                                <tr key={index}>
                                    <td className="fw-bold w-50 text-start table-light">
                                        {key} Sales
                                    </td>
                                    <td className="w-50 text-start fw-semibold">
                                        {currencyFormatWithAlert(value, currency)}

                                    </td>
                                </tr>
                            ))}

                        {/* ✅ Discount Row */}
                        <tr>
                            <td className="fw-bold w-50 text-start table-light">Discount</td>
                            <td className="w-50 text-start fw-semibold">

                                {data?.discountedItems?.length
                                    ? currencyFormatWithAlert(data.discountedItems
                                        .reduce((acc, item) => acc + (Number(item.discount) || 0), 0)
                                        .toFixed(2), currency)
                                    : currencyFormatWithAlert("0.00", currency)}
                            </td>
                        </tr>

                        {/* ✅ Total Row */}
                        <tr>
                            <td className="fw-bold w-50 text-start table-light">Total</td>
                            <td className="w-50 text-start fw-semibold ">
                                {currencyFormatWithoutDecimal(data?.itemData?.revenue, currency)}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

        </React.Fragment>
    );
};

export default CheckListingPopup;
